import type { UnderwriterSearchRequestQuery } from '@lio/api-types';

type UnderwriterIncludeDeletedQueryValue = UnderwriterSearchRequestQuery['includeDeleted'] | 'true' | 'false';

export type UnderwriterSearchRequestQueryWithOutOfOffice = Omit<UnderwriterSearchRequestQuery, 'includeDeleted'> & {
  includeDeleted?: UnderwriterIncludeDeletedQueryValue;
  isOutOfOffice?: boolean;
};

export const searchUnderwriterQueryParams = (params: UnderwriterSearchRequestQueryWithOutOfOffice) => {
  const {
    name,
    email,
    sort,
    pageLimit,
    pageOffset,
    includeCountOpenQuotes,
    includeDeleted,
    canAutoAssignTo,
    canOverrideIssuingCompany,
    isOutOfOffice,
  } = params;
  const query = new URLSearchParams();

  if (name) {
    query.append('name', name);
  }
  if (email) {
    query.append('email', email);
  }
  if (includeCountOpenQuotes) {
    query.append('includeCountOpenQuotes', 'true');
  }
  if (canAutoAssignTo !== undefined) {
    query.append('canAutoAssignTo', String(canAutoAssignTo));
  }
  if (canOverrideIssuingCompany !== undefined) {
    query.append('canOverrideIssuingCompany', String(canOverrideIssuingCompany));
  }
  if (isOutOfOffice !== undefined) {
    query.append('isOutOfOffice', String(isOutOfOffice));
  }
  if (sort) {
    query.append('sort', sort);
  }
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }

  if (includeDeleted === true || includeDeleted === 'true') {
    query.append('includeDeleted', 'true');
  }

  return query.toString();
};
